import { render, staticRenderFns } from "./labelList.vue?vue&type=template&id=4a72655d&scoped=true"
import script from "./labelList.vue?vue&type=script&lang=js"
export * from "./labelList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a72655d",
  null
  
)

export default component.exports